import React from "react";
import { Oval } from "react-loader-spinner";
import styles from "./Loader.scss";

export default function Loader(props) {
    return (
        <div className={styles.root}>
            <Oval />
        </div>
    );
}